/** @format */

import React, { useState, useEffect } from "react";
import { Layout, Row, Col, Drawer, message ,Modal} from "antd";
import ProductCard from "./ProductCard";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin } from "antd";
import Link from "next/link";
import { LoadingOutlined } from "@ant-design/icons";
import { registerToApp } from "../AuthWithKeycloak";
import { useKeycloak } from "@react-keycloak/ssr";
import { useRouter } from "next/router";
import AddToCollection from "../common/AddToCollection";
import AddToCollectionSignUp from "../ProductDescription/AddToCollectionSignUp"

const { Content } = Layout;

function ContentSection(props) {
  let {
    content = [],
    count = 0,
    pageId,
    pageName = '',
    isMobile = false,
    loadMoreData,
    sellerId = "",
    recentlyViewed = false,
    currentPageIndex,
    totalPages,
    searchBy,
    getOnScroll,
    fromSimilar,
    isLoading,
    isAuthenticated = false
  } = props;

  const [contentData, setContent] = useState(null);
  const [collections, setCollections] = useState([]);
  const [selProductId, setSelProductId] = useState("");
  const [open, setOpen] = useState();
  const [selectedCollection, setSelectedCollection] = useState("");
  const [showCollection, setCollection] = useState(false);
  const [viewSellerCode, setSellerCode] = useState('');
  const [loader, setLoader] = useState(false);
  const [collectionPrice,setCollectionPrice] = useState(0);
  const [currentCurrency,setCurrentCorrency] = useState("");

useEffect(()=>{
  if(props?.content){
    setContent(props?.content)
  }
},[props])


  const { keycloak } = useKeycloak();
  const router = useRouter();

  const handleClickOutside = (e) => {
    setOpen(false);
    setSelProductId("");
  };
  const handleCancel = () => {
    setCollection(false)

  };

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  useEffect(() => {
    let { collections = [] } = props || {};
    setCollections(collections);
  }, [props.collections]);

  useEffect(() => {
      let collectionPIds = [];
      if (collections && collections.length) {
        for (let list of collections) {
          let { products = [], name = "" } = list;
          for (let product of products) {
            let { articleId = "" } = product;
            if (articleId) {
              collectionPIds.push(articleId);
            }
          }
        }
      }
      
      let newContent = [];
      if (content && content.length > 0) {
        for(let i = 0; i < content.length; i++){
          let pId = content[i].id?.replace("PRODUCT::", "");
          if(collectionPIds.find(elm => elm * 1 == pId)){
            content[i].isIncollections = true
          }else{
            content[i].isIncollections = false
          }
          newContent.push(content[i]);
        }
      }
      setContent(newContent)
  }, [content, collections]);

  const selectProduct = (productId) => {
    setSelProductId(productId);
    setOpen(!open);
  };

  const setCollectionName = (articleId, sellerCode) => {
    // setSelectedCollection("");
    setCollection(true);
    setSelProductId(articleId);
    setSellerCode(sellerCode);
    if (collections && collections.length) {
      for (let list of collections) {
        let { products = [], name = "" } = list;
        for (let product of products) {
          let { articleId: pArticleId = "" } = product;
          // if (pArticleId === articleId) {
          //   setSelectedCollection(name);
          // }
        }
      }
    }
  }
  
  if (contentData && contentData.length > 0) {
    return (
      <Content>
        <InfiniteScroll
          dataLength={contentData.length}
          next={loadMoreData}
          hasMore={pageName === 'search-listing' ? (totalPages - currentPageIndex) : count > contentData.length}
          scrollThreshold="80%"
          onScroll={getOnScroll}
          loader={
            <div
              className="qa-mar-btm-4 qa-mar-top-2 qa-font-san qa-pad-0-30"
              style={{ textAlign: "center" }}
            >
              <div style={{ textAlign: "center" }}>
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{ fontSize: 24, color: "black" }}
                      spin
                    />
                  }
                  tip={
                    <div className="qa-pad-top-10">
                      "I have just unloaded the boxes and started checking out
                      the products. We are so happy with the goods! THANK YOU!"
                      <div className="qa-stitle">
                        Online retailer, New Zealand
                      </div>
                    </div>
                  }
                  size="large"
                  style={{
                    verticalAlign: "middle",
                    color: "black",
                  }}
                />
              </div>
            </div>
          }
          endMessage={
            <div
              className="qa-mar-btm-4 qa-mar-top-2 qa-font-san qa-pad-0-30"
              style={{ textAlign: "center" }}
            >
              <div style={{ textAlign: "center" }}>
                <span className="dot one"></span>
                <span className="dot two"></span>
                <span className="dot three"></span>
              </div>
              You have reached the end of the listing.
              <br></br>We are constantly adding new sellers and products. Stay
              tuned!
            </div>
          }
        >
          <Row>
            {contentData.map((values, index) => {
              values.key = index;
              let searchValues = searchBy === 'seller' ? values : values.record || values;
              if(pageName === 'search-listing' && searchBy === 'product'){
                searchValues.productName = searchValues?.name;
                searchValues.key = index;
              }
                return (
                  <>
                    {(index === 6 && pageName === 'product-listing') ?
                      isAuthenticated ?
                        isMobile ?
                          <Col 
                            className="plp_offer_banner_aftr6 qa-pad-3 qa-pad-top-2"
                            xs={24}
                            sm={24}
                          >
                              <img
                                src="https://cdn.qalara.com/images/PLP_testimonial_mobile_1_04_25.jpg"
                                alt="Qalara trusted by buyers from 5 continents"
                              />
                          </Col>
                          :
                          <Col 
                            className="plp_offer_banner_aftr6 qa-pad-3 qa-pad-top-2"
                            xs={24}
                            sm={24}
                          >
                              <img
                                src="https://cdn.qalara.com/images/PLP_testimonial_website_1_04_25.jpg"
                                alt="Qalara trusted by buyers from 5 continents"
                              />
                          </Col>
                        :
                          isMobile ?
                          <Col 
                            className="plp_offer_banner_aftr6 qa-pad-3 qa-pad-top-2 qa-cursor"
                            xs={24}
                            sm={24}
                          >
                            <img
                              src="https://cdn.qalara.com/images/PLP_testimonial_mobile_1_04_25.jpg"
                              alt="Qalara trusted by buyers from 5 continents"
                            />
                          </Col>
                          :
                          <Col 
                            className="plp_offer_banner_aftr6 qa-pad-3 qa-pad-top-2 qa-cursor"
                            xs={24}
                            sm={24}
                          >
                            <img
                              src="https://cdn.qalara.com/images/PLP_testimonial_website_1_04_25.jpg"
                              alt="Qalara trusted by buyers from 5 continents"
                            />
                          </Col>
                      
                    :
                      null
                    }
                    
                    <Col
                      className="qa-pad-3 qa-pad-top-2"
                      key={index}
                      xs={24}
                      sm={24}
                      md={recentlyViewed ? 8 : 12}
                      lg={recentlyViewed ? 6 : 8}
                      xl={recentlyViewed ? 6 : 8}
                    >
                      <ProductCard
                        key={index}
                        data={pageName =='search-listing' ? searchValues : values}
                        pageId={pageId}
                        pageName={pageName}
                        isMobile={isMobile}
                        selectedProductId={selProductId}
                        selectProduct={selectProduct}
                        sellerId={sellerId}
                        recentlyViewed={recentlyViewed}
                        setCollectionName={setCollectionName}
                        slp_content={contentData}
                        fromSimilar={fromSimilar}
                        isLoading={isLoading}
                        isAuthenticated={isAuthenticated}
                        setCurrentCorrency={setCurrentCorrency}
                        setCollectionPrice={setCollectionPrice}
                      />
                    </Col>
                  </>
                )
              }
            )}
          </Row>

       {  (!props?.userProfile?.profileId || props?.userProfile?.userProfile) ? ( <Modal
        visible={showCollection}
        footer={null}
        closable={false}
        onCancel={handleCancel}
        centered
        bodyStyle={{ padding: "40px", backgroundColor: "#F9F7F2" }}
        width={700}
        className="product-login-modal"
      >
        <AddToCollectionSignUp handleCancel={handleCancel} />
      </Modal>) :
 (         <Drawer
            placement={isMobile ? "bottom" : "right"}
            closable={false}
            width={isMobile ? "100%" : "330px"}
            bodyStyle={{ padding: "20px" }}
            onClose={() => setCollection(false)}
            visible={showCollection}
          >
            <AddToCollection
              contentData={contentData}
              onClose={() => setCollection(false)}
              savedProductToCollection={(name) => setSelectedCollection(name)}
              userCollections={props.collections}
              userProfile={props.userProfile}
              articleId={selProductId}
              sellerCode={viewSellerCode}
              selectedCollection={selectedCollection}
              token={props.token}
              refreshCollection={(collections) => setCollections(collections)}
              setAnimationLoader={(status) => setLoader(status)}
              collectionPrice={collectionPrice}
              currentCurrency={currentCurrency}
            />
          </Drawer>)}
        </InfiniteScroll>
      </Content>
    );
  } else {
    return <div></div>;
  }
}

export default ContentSection;
